import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: {
                    "hello": "Hello",
                    "usernameHead": "Welcome, {{username}}",
                    "loginUser": "User",
                    "loginPassword": "Password",
                    "loginButton": "Sign in",
                    "loginValidationFields": "Please fill in both fields",
                    "loginError": "There was an error logging in",
                    "navBarPending": "Pending",
                    "navBarDone": "Done",
                    "surveyEndLayoutMessageFinish": "You have completed the survey.",
                    "surveyEndLayoutMessageGratitude": "Thank you very much for dedicating your time to us.",
                    "surveyPendingButtonReply": "Reply",
                    "surveyPendingQuestionButtonNext": "Next",
                    "surveyDoneButtonSeeAnswers": "See answers"

                }
            },
            es: {
                translation: {
                    "hello": "Hola",
                    "usernameHead": "Bienvenido, {{username}}",
                    "loginUser": "Usuario",
                    "loginPassword": "Contraseña",
                    "loginButton": "Entrar",
                    "loginValidationFields": "Por favor rellene ambos campos",
                    "loginError": "Hubo un error al iniciar sesión",
                    "navBarPending": "Pendiente",
                    "navBarDone": "Realizadas",
                    "surveyEndLayoutMessageFinish": "Has finalizado la encuesta.",
                    "surveyEndLayoutMessageGratitude": "Muchas gracias por dedicarnos tu tiempo.",
                    "surveyPendingButtonReply": "Responder",
                    "surveyPendingQuestionButtonNext": "Siguiente",
                    "surveyDoneButtonSeeAnswers": "Ver respuestas"

                }
            },
            ca: {
                translation: {
                    "hello": "Hola",
                    "usernameHead": "¡Bienvenido, {{username}}!",
                    "loginUser": "Usuari",
                    "loginPassword": "Contrasenya",
                    "loginButton": "Entrar",
                    "loginValidationFields": "Si us plau, omple els dos camps",
                    "loginError": "Hi va haver un error en iniciar sessió",
                    "navBarPending": "Pendents",
                    "navBarDone": "Realitzades",
                    "surveyEndLayoutMessageFinish": "Has finalizat l'enquesta.",
                    "surveyEndLayoutMessageGratitude": "Moltes grácies per dedicar-nos el teu temps.",
                    "surveyPendingButtonReply": "Respondre",
                    "surveyPendingQuestionButtonNext": "Següent",
                    "surveyDoneButtonSeeAnswers": "Veure respostes"
                }
            },
            fr: {
                translation: {
                    "hello": "Bonjour",
                    "usernameHead": "Bienvenue, {{username}}!",
                    "loginUser": "Utilisateur",
                    "loginPassword": "Mot de passe",
                    "loginButton": "Se connecter",
                    "loginValidationFields": "Veuillez remplir les deux champs",
                    "loginError": "Une erreur est survenue lors de la connexion",
                    "navBarPending": "En attente",
                    "navBarDone": "Terminées",
                    "surveyEndLayoutMessageFinish": "Vous avez terminé l'enquête.",
                    "surveyEndLayoutMessageGratitude": "Merci beaucoup d'avoir pris le temps de répondre.",
                    "surveyPendingButtonReply": "Répondre",
                    "surveyPendingQuestionButtonNext": "Suivant",
                    "surveyDoneButtonSeeAnswers": "Voir les réponses"
                }
            }
        },
        lng: "ca", // Idioma por defecto
        fallbackLng: "ca", // Idioma de respaldo
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
